import React, { useEffect } from 'react'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { Router } from './routes'
import { useApp } from './useApp'
import ReactDOM from 'react-dom/client'
import { initSentry } from './utils'
import './App.module.scss'
import Layout from 'components/Layout/Layout'

const { REACT_APP_NODE_ENV } = process.env

let environment = REACT_APP_NODE_ENV
if (environment === 'pull_request' || environment === 'local') {
  environment = 'development'
}

const { REACT_APP_PLURALL_FEEDBACK_ID } = process.env

initSentry()

async function initializePlurallTracker(timeout = 3000) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now()

    const checkTracker = () => {
      if (window.PlurallTracker) {
        window.PLURALL_TRACKER = new window.PlurallTracker({
          clientId: 'login',
          environment,
          plurallFeedback: +REACT_APP_PLURALL_FEEDBACK_ID!,
        })

        // @ts-ignore
        resolve()
      } else if (Date.now() - startTime > timeout) {
        reject(console.error('Timeout waiting for PlurallTracker to initialize'))
      } else {
        setTimeout(checkTracker, 100)
      }
    }

    checkTracker()
  })
}

initializePlurallTracker().catch(error => {
  console.error('Failed to initialize PlurallTracker:', error)
})

const Main = () => {
  useApp()

  return (
    <Layout>
      <Router />
    </Layout>
  )
}

const App = () => {
  const location = useLocation()

  useEffect(() => {
    if ('PLURALL_TRACKER' in window) {
      window.PLURALL_TRACKER.pageView()
    }
  }, [location])

  return <Main />
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
)
